module.exports = __webpack_public_path__ + "media/images/emblems/CH_Belmont-Broye_COA-eee48ad60ca6215ff5eaacc4ab7851e1.svg";